import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { useFormikContext, Formik, useField } from "formik";
import axios from "../../utils/axios";
import { Form, Alert, Row, Col } from "react-bootstrap";

const AddForm = ({
  isSubmitting,
  formRef,
  toggle,
  alert,
  listId,
  ...props
}: any) => {
  const [makes, setMakes] = useState([]);
  const [alertChannels, setAlertChannels] = useState([]);
  const [alertChannel, setAlertChannel] = useState({ id: 0 });

  const numberFormatter = new Intl.NumberFormat("sl-SI", {
    maximumFractionDigits: 0,
  });
  const currencyFormatter = new Intl.NumberFormat("sl-SI", {
    style: "currency",
    currency: "EUR",
    maximumFractionDigits: 0,
  });
  const year = new Date().getFullYear();
  const yearsArray = Array.from({ length: 45 }, (v, i) => {
    return { label: year - i, value: year - i };
  });
  const kilometersArray = Array.from({ length: 30 }, (v, i) => {
    let number = (i + 1) * 10000;
    if (i >= 20) {
      number = (i - 15) * 50000;
    }

    return { label: numberFormatter.format(number), value: number };
  });
  const pricesArray = Array.from({ length: 40 }, (v, i) => {
    if (i === 0) {
      const number = (i + 1) * 100;
      return { label: currencyFormatter.format(number), value: number };
    } else if (i < 11) {
      const number = i * 500;
      return { label: currencyFormatter.format(number), value: number };
    } else if (i < 26) {
      const number = (i - 5) * 1000;
      return { label: currencyFormatter.format(number), value: number };
    } else if (i < 34) {
      const number = (i - 17) * 2500;
      return { label: currencyFormatter.format(number), value: number };
    } else if (i < 40) {
      const number = (i - 29) * 10000;
      return { label: currencyFormatter.format(number), value: number };
    }
    return null;
  });

  const hoursArray = Array.from({ length: 29 }, (v, i) => {
    let number = (i + 1) * 100;
    if (i >= 9) {
      number = (i - 8) * 1000;
    }

    return { label: numberFormatter.format(number), value: number };
  });

  const Model = (props: any) => {
    const [models, setModels] = useState([]);
    const {
      values: { make, model },
    }: {
      values: any;
    } = useFormikContext();
    const [field, meta, helpers] = useField(props);
    const { setValue } = helpers;

    useEffect(() => {
      if (make && make.trim() !== "") {
        setModels(
          makes
            .filter((make_: any) => make_.make === make)
            .map((make_: any) => make_.models)
            .reduce((value, model) => {
              value.push(...model);
              return value;
            }, [])
        );
      } else {
        setModels([]);
      }
    }, [make]);

    useEffect(() => {
      if (!models.length || model || !alert?.model) {
        return;
      }
      setValue(alert.model);
    }, [models, setValue, model]);

    return (
      <>
        <Form.Select {...props} {...field}>
          <option value=""></option>
          {models.map((value: any, index) => (
            <option value={value} key={"model_" + index}>
              {value}
            </option>
          ))}
        </Form.Select>
        {!!meta.touched && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </>
    );
  };

  const SelectWithFilter = ({
    filterFunc,
    watchField,
    dataArray = [],
    ...props
  }: any) => {
    const [selectValues, setSelectValues] = useState(dataArray);
    const {
      values,
    }: {
      values: any;
    } = useFormikContext();
    const [field, meta] = useField(props);
    const value = values[watchField];

    useEffect(() => {
      if (value !== 0 && filterFunc) {
        setSelectValues(
          dataArray.filter((filterValue: number) => {
            return filterFunc(filterValue, value);
          })
        );
      } else {
        setSelectValues(dataArray);
      }
    }, [value, filterFunc, dataArray]);

    return (
      <>
        <Form.Select {...props} {...field}>
          <option value=""></option>
          {selectValues.map((value: any, index: number) => (
            <option
              value={value.value}
              key={"select_" + watchField + "_" + index}
            >
              {value.label}
            </option>
          ))}
        </Form.Select>
        {!!meta.touched && (
          <Form.Control.Feedback type="invalid">
            {meta.error}
          </Form.Control.Feedback>
        )}
      </>
    );
  };

  useEffect(() => {
    if (makes.length) {
      return;
    }
    let url = "/makes";
    if (listId === "2") {
      url = "/makes/trucks";
    } else if (listId === "3") {
      url = "/makes/machines";
    }
    axios
      .get(url)
      .then((result) => {
        setMakes(result.data.make);
      })
      .catch((e) => console.error(e));
  }, [makes, listId]);

  useEffect(() => {
    if (alertChannels.length) {
      return;
    }
    axios
      .get("/alerts/channels")
      .then((result) => {
        setAlertChannels(result.data.alertChannels);
        if (result.data.alertChannels.length) {
          setAlertChannel(result.data.alertChannels[0]);
        }
      })
      .catch((e) => console.error(e));
  }, [alertChannels]);

  const yearsFromFilter = (year: { value: number }, yearLimit: number) => {
    return year.value <= yearLimit;
  };

  const yearsToFilter = (year: { value: number }, yearLimit: number) => {
    return year.value >= yearLimit;
  };

  const filterSmallerValues = (
    value: { value: number },
    valueLimit: number
  ) => {
    return value.value < valueLimit;
  };

  const filterBiggerValues = (value: { value: number }, valueLimit: number) => {
    return value.value > valueLimit;
  };

  return (
    <Formik
      innerRef={formRef}
      enableReinitialize={true}
      initialValues={{
        make: alert.make,
        model: alert.model,
        yearFrom: alert.yearFrom || 0,
        yearTo: alert.yearTo || 0,
        priceFrom: alert.priceFrom || 0,
        priceTo: alert.priceTo || 0,
        kilometersFrom: alert.kilometersFrom || 0,
        kilometersTo: alert.kilometersTo || 0,
        alertChannelId: alert.alertChannelId || alertChannel.id,
        listId: listId,
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        make: Yup.string().max(255).required("Prosim izberi znamko"),
        model:
          !listId || listId === "1"
            ? Yup.string().max(255).required("Prosim izberi model")
            : Yup.string().max(255),
        yearFrom: Yup.number().integer().nullable(),
        yearTo: Yup.number().integer().nullable(),
        priceFrom: Yup.number().integer().nullable(),
        priceTo: Yup.number().integer().nullable(),
        kilometersFrom: Yup.number().integer().nullable(),
        kilometersTo: Yup.number().integer().nullable(),
        alertChannelId: Yup.number()
          .integer()
          .required("Prosim izberi način obveščanja"),
      })}
      onSubmit={async (
        values: any,
        { setErrors, setStatus, setSubmitting }
      ) => {
        try {
          const submitValues = Object.keys(values).reduce(
            (allValues: any, key: any) => {
              if (values[key] === 0) {
                allValues[key] = null;
              } else {
                allValues[key] = values[key];
              }
              return allValues;
            },
            {}
          );

          let response;
          if (alert.id) {
            response = await axios
              .put("/alerts/" + alert.id, submitValues)
              .catch((e) => {
                throw e;
              });
          } else {
            response = await axios.post("/alerts", submitValues).catch((e) => {
              throw e;
            });
          }

          if (response) {
            toggle(true);
          }
        } catch (error: any) {
          console.error(error);
          const message = error.message || "Prišlo je do napake";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <Form onSubmit={handleSubmit} key="form">
          {errors.submit && (
            <Alert variant="danger">
              <div className="alert-message">{errors.submit}</div>
            </Alert>
          )}
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="make">Znamka</Form.Label>
                <Form.Select
                  name="make"
                  id="make"
                  as="input"
                  size="lg"
                  value={values.make}
                  placeholder="Vpiši znamko"
                  isInvalid={Boolean(touched.make && errors.make)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Znamka"
                >
                  <option value=""></option>
                  {makes.map((value: any, index) => (
                    <option value={value.make} key={"make_" + index}>
                      {value.make}
                    </option>
                  ))}
                </Form.Select>
                {!!touched.make && (
                  <Form.Control.Feedback type="invalid">
                    {errors.make}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
            {!listId || listId === "1" ? (
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="model">Model</Form.Label>
                  <Model
                    name="model"
                    id="model"
                    as="input"
                    size="lg"
                    disabled={!values.make}
                    value={values.model}
                    placeholder="Vpiši model"
                    isInvalid={Boolean(touched.model && errors.model)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Izberi model"
                  />
                </Form.Group>
              </Col>
            ) : (
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="model">
                    {listId === "3" ? "Opis" : "Model"}
                  </Form.Label>
                  <Form.Control
                    type="text"
                    id="model"
                    name="model"
                    as="input"
                    size="lg"
                    value={values.model}
                    isInvalid={Boolean(touched.model && errors.model)}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Model"
                  />
                </Form.Group>
              </Col>
            )}
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="priceFrom">Cena od</Form.Label>
                <SelectWithFilter
                  name="priceFrom"
                  id="priceFrom"
                  as="input"
                  size="lg"
                  value={values.priceFrom}
                  placeholder="Izberi leto"
                  isInvalid={Boolean(touched.priceFrom && errors.priceFrom)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Cena od"
                  filterFunc={filterSmallerValues}
                  watchField="priceTo"
                  dataArray={pricesArray}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="priceTo">Cena do</Form.Label>
                <SelectWithFilter
                  name="priceTo"
                  id="priceTo"
                  as="input"
                  size="lg"
                  value={values.priceTo}
                  placeholder="Izberi leto"
                  isInvalid={Boolean(touched.priceTo && errors.priceTo)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Leto do"
                  filterFunc={filterBiggerValues}
                  watchField="priceFrom"
                  dataArray={pricesArray}
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="yearFrom">Letnik od</Form.Label>
                <SelectWithFilter
                  name="yearFrom"
                  id="yearFrom"
                  as="input"
                  size="lg"
                  value={values.yearFrom}
                  placeholder="Izberi leto"
                  isInvalid={Boolean(touched.yearFrom && errors.yearFrom)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Leto od"
                  filterFunc={yearsFromFilter}
                  watchField="yearTo"
                  dataArray={yearsArray}
                />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="yearTo">Letnik do</Form.Label>
                <SelectWithFilter
                  name="yearTo"
                  id="yearTo"
                  as="input"
                  size="lg"
                  value={values.yearTo}
                  placeholder="Izberi leto"
                  isInvalid={Boolean(touched.yearTo && errors.yearTo)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Leto do"
                  filterFunc={yearsToFilter}
                  watchField="yearFrom"
                  dataArray={yearsArray}
                />
              </Form.Group>
            </Col>
          </Row>
          {!listId || listId === "1" ? (
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="kilometersFrom">Kilmetri od</Form.Label>
                  <SelectWithFilter
                    name="kilometersFrom"
                    id="kilometersFrom"
                    as="input"
                    size="lg"
                    value={values.kilometersFrom}
                    placeholder="Izberi kilometre"
                    isInvalid={Boolean(
                      touched.kilometersFrom && errors.kilometersFrom
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Kilometri od"
                    filterFunc={filterSmallerValues}
                    watchField="kilometersTo"
                    dataArray={kilometersArray}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="kilometersTo">Kilmetri do</Form.Label>
                  <SelectWithFilter
                    name="kilometersTo"
                    id="kilometersTo"
                    as="input"
                    size="lg"
                    value={values.kilometersTo}
                    placeholder="Izberi kilometre"
                    isInvalid={Boolean(
                      touched.kilometersTo && errors.kilometersTo
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Kilometri do"
                    filterFunc={filterBiggerValues}
                    watchField="kilometersFrom"
                    dataArray={kilometersArray}
                  />
                </Form.Group>
              </Col>
            </Row>
          ) : (
            <Row>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="kilometersFrom">Ure od</Form.Label>
                  <SelectWithFilter
                    name="kilometersFrom"
                    id="kilometersFrom"
                    as="input"
                    size="lg"
                    value={values.kilometersFrom}
                    placeholder="Izberi ure"
                    isInvalid={Boolean(
                      touched.kilometersFrom && errors.kilometersFrom
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Ure od"
                    filterFunc={filterSmallerValues}
                    watchField="kilometersTo"
                    dataArray={hoursArray}
                  />
                </Form.Group>
              </Col>
              <Col>
                <Form.Group className="mb-3">
                  <Form.Label htmlFor="kilometersTo">Ure do</Form.Label>
                  <SelectWithFilter
                    name="kilometersTo"
                    id="kilometersTo"
                    as="input"
                    size="lg"
                    value={values.kilometersTo}
                    placeholder="Izberi ure"
                    isInvalid={Boolean(
                      touched.kilometersTo && errors.kilometersTo
                    )}
                    onBlur={handleBlur}
                    onChange={handleChange}
                    aria-label="Ure do"
                    filterFunc={filterBiggerValues}
                    watchField="kilometersFrom"
                    dataArray={hoursArray}
                  />
                </Form.Group>
              </Col>
            </Row>
          )}

          <hr className="border-top" />

          <Row>
            <Col>
              <Form.Group className="mb-3">
                <Form.Label htmlFor="alertChannelId">Obveščanje</Form.Label>
                <Form.Select
                  name="alertChannelId"
                  id="alertChannelId"
                  as="input"
                  size="lg"
                  value={values.alertChannelId}
                  placeholder="Izberi način obveščanja"
                  isInvalid={Boolean(
                    touched.alertChannelId && errors.alertChannelId
                  )}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  aria-label="Obveščanje"
                >
                  <option></option>
                  {alertChannels.map((value: any, index: number) => (
                    <option value={value.id} key={"alertChannelId_" + index}>
                      {value.type}: {value.name}
                    </option>
                  ))}
                </Form.Select>
                {!!touched.alertChannelId && (
                  <Form.Control.Feedback type="invalid">
                    {errors.alertChannelId}
                  </Form.Control.Feedback>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default AddForm;
